import React, { useState, useEffect } from "react";
import Footer from "../components/footer/footer";
import Header from "../components/header/header";
import Error from "./Error";
import Models from "./SalesOffice";
import Users from "./Users";
import Tools from "./Tools";
import SalesUsers from "./SalesUsers";
import Reports from "./Reports";
// import Views from "./Views";
// import Drawings from "./Drawings";
import * as miscAction from "../actions/miscAction";
import { connect } from "react-redux";
import DMTabContainer from "../components/common/controls/DMTabContainer";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { HasPermission } from "../utilities/applicationutils";
// import * as dataDescriptionAction from "../actions/dataDescriptionAction";
import Loading from "../components/Loading/Loading";
import SalesOffice from "./SalesOffice";
import AppRoutes from "../routers/routes";
import { useParams } from "react-router-dom";
var CONTROLS_DATA = require("./ControlsData.json");

const SalesOfficeLevel = ({
  permissions,
  miscState,
  onTabSelected,
  setSnackBar,
  getConfigGroups,
  regionId
}) => {
  // const [selectedTab, setSelectedTab] = useState(0);

  // const [tabs, setTabs] = useState(CONTROLS_DATA.SCREENS.REGIONS_LEVEL_TAB_NAMES);
  // const [snackbarDetails, setSnackBarDetails] = useState(miscState.snackbar);
  
  console.log("regionId====>",regionId);
  // let { regionId } = useParams(); 
  // const getContainer = () => {
  //   return <AppRoutes selectedTab={selectedTab}/>
  // };

  /* Enable/Disable tabs */
  // const updateTabs = (seletedTab, data) => {
  //   const updateTabs = data.map((item, index) => {
  //     if (seletedTab !== index) {
  //       return { ...item, disabled: false };
  //     }
  //     return item;
  //   });
  //   return updateTabs;
  // };

  // useEffect(() => {
  //   setSelectedTab(miscState.selectedTab);
  //   if (miscState.selectedTab === 0) {
  //     setTabs(CONTROLS_DATA.SCREENS.REGIONS_LEVEL_TAB_NAMES);
  //   } else {
  //     const tabs = updateTabs(
  //       miscState.selectedTab,
  //       CONTROLS_DATA.SCREENS.REGIONS_LEVEL_TAB_NAMES
  //     );
  //     setTabs(tabs);
  //   }
  // }, [miscState.selectedTab]);

  // useEffect(() => {
  //   if (miscState.selectedModel) {
  //     setTabs(
  //       tabs.map((t) => {
  //         return { ...t, disabled: false };
  //       })
  //     );
  //   }
  //   setTabs(
  //     tabs.map((t) => {
  //       return { ...t, disabled: false };
  //     })
  //   );
  // }, [miscState.selectedModel]);

  // useEffect(() => {
  //   if (miscState?.selectedModel) getConfigGroups(miscState.selectedModel);
  // }, [miscState.selectedModel]);

  // useEffect(() => {
  //   setSnackBarDetails(miscState.snackbar);
  // }, [miscState.snackbar]);

  return (
    <>
      <Loading />
      {/* <Header permission={permissions} /> */}
      {/* <h1> Test Region Levels</h1> */}
      <SalesOffice permissions={permissions} regionId={regionId} />
      {/* {readPermission ? (
        <>
          <DMTabContainer
            tabs={tabs}
            defaultActiveTab={selectedTab}
            onTabChange={onTabSelected}
            alignment={"center"}
          />
          <div>{getContainer()}</div>
        </>
      ) : ( 
        <>
          <DMTabContainer
            tabs={tabs}
            defaultActiveTab={selectedTab}
            onTabChange={onTabSelected}
            alignment={"center"}
          />
          <div>{getContainer()}</div>
        </>
      )} */}
      {/* <Snackbar
        open={snackbarDetails?.show}
        autoHideDuration={3000}
        onClose={() => setSnackBar(false, "", "")}
        style={{ zIndex: "111111" }}
      >
        <Alert
          onClose={() => setSnackBar(false, "", "")}
          severity={snackbarDetails?.severity}
        >
          {snackbarDetails?.message}
        </Alert>
      </Snackbar> */}
      <Footer />
    </>
  );
};
const mapStateToProps = (state) => ({
  miscState: state.misc,
});

const mapDispatchToProps = (dispatch) => {
  return {
    onTabSelected: (tabId) => dispatch(miscAction.onTabSelected(tabId)),
    // getConfigGroups: async (requestPayload) =>
      // dispatch(dataDescriptionAction.getConfigGroups(requestPayload)),
    setSnackBar: (show, severity, message) =>
      dispatch(miscAction.setSnackBar(show, severity, message)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SalesOfficeLevel);
